import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router";
import moment from "moment";
import util from "../util/util";

export default function ConflictFormRule(props) {
  // rule content to display;
  const [rule, setRule] = useState({});

  useEffect(() => {
    setRule(props.rule);
  }, [props.rule]);

  return (
    <div>
      <h4 className="page__header">Selected Rule</h4>

      <div className="well">
        <div className="row">
          <div className="col-sm-4">
            <h4 className="page__header">Rule Name:</h4>
            <p>{rule.name}</p>
          </div>
          <div className="col-sm-4">
            <h4 className="page__header">Start Date:</h4>
            <p>{moment(rule.dateStart).format(util.dateFormatHumanLong)}</p>
          </div>
          <div className="col-sm-4">
            <h4 className="page__header">Time Slots / Shows:</h4>
            {rule.timeslots && rule.timeslots.length > 0 ? (
              <p>{util.returnCleanTimeSlots(rule.timeslots).join(`, `)}</p>
            ) : null}
            {rule.shows && rule.shows.length > 0
              ? util.renderShowsNames(rule.shows)
              : null}
          </div>
        </div>

        <div className="row">
          {rule.pod ? (
            <div className="col-sm-4">
              <h4 className="page__header">Source Pod</h4>
              <p>
                <Link to={util.returnPodDetailUrl(rule.pod.id)}>
                  {rule.pod.name}
                </Link>
              </p>
            </div>
          ) : null}
          {rule.campaign ? (
            <div className="col-sm-4">
              <h4 className="page__header">Source Campaign</h4>
              <p>
                <Link to={util.returnCampaignDetailUrl(rule.campaign.id)}>
                  {rule.campaign.name}
                </Link>
              </p>
            </div>
          ) : null}
          <div className="col-sm-4">
            <h4 className="page__header">End Date:</h4>
            <p>{moment(rule.dateEnd).format(util.dateFormatHumanLong)}</p>
          </div>
          <div className="col-sm-4">
            <h4 className="page__header">Repeats:</h4>
            <p>{util.returnRepeatValue(rule.repeats)}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

ConflictFormRule.propTypes = {
  rule: PropTypes.object
};
